/*
 * @Author: your name
 * @Date: 2021-01-14 13:54:06
 * @LastEditTime: 2021-09-26 15:37:25
 * @LastEditors: yang chenglin
 * @Description: 销售情况付款占比
 * @FilePath: \CJYX_DouYin\src\pages\Home\components\DYCharts\index.tsx
 */
import React, { useEffect, useState } from 'react';
import { Servlets } from '@/service';
import { Chart, Legend, LineAdvance } from 'bizcharts';
import moment from 'moment';
import styles from './index.module.scss';

const DYCharts = () => {
  const scale = {
    percentage: {
      alias: '占比',
      min: 0,
      max: 100,
      formatter: (val) => {
        return `${val }%`;
      },
    },
  };
  const [initData, setInitData] = useState([]);
  useEffect(() => {
    Servlets('getPaymentChart', {}).then((res) => {
      if (res.data) {
        res.data.sort((a, b) => {
          return a.time - b.time;
        });
        res.data.forEach((item) => {
          item.time = moment(item.time).format('YYYY-MM-DD');
          item.percentage = +item.percentage;
        });
      }
      setInitData(res.data);
    });
  }, []);
  return (
    <div
      style={{
        width: '49.5%',
        background: '#fff',
        boxShadow: '0px 2px 15px 0px rgba(169, 182, 199, 0.2)',
        borderRadius: '10px',
        height: '440px',
      }}
      className="marginB-20"
    >
      <div className={styles.topTitle}>付款占比（近7日）</div>
      <Chart
        autoFit
        height={350}
        data={initData}
        padding={40}
        scale={scale}
      >
        <Legend visible={false} />
        <LineAdvance shape="smooth" point area position="time*percentage" />
      </Chart>
    </div>
  );
};

export default DYCharts;
